module.exports = __webpack_public_path__ + "static/media/heart.5597c41e.webp";